"use client";
import React from "react";
import { FaMedal, FaUserGraduate, FaTrophy, FaChartLine } from "react-icons/fa";

const AchieveYourGoals = ({ achievements, loading }: any) => {
  const items = [
    {
      icon: <FaMedal className="text-primaryColor text-4xl mb-4" />,
      title: `+${achievements?.users_count} طالب متفوق`,
    },
    {
      icon: <FaUserGraduate className="text-primaryColor text-4xl mb-4" />,
      title: `+${achievements?.teachers_count} معلم معتمد`,
    },
    {
      icon: <FaTrophy className="text-primaryColor text-4xl mb-4" />,
      title: `+${achievements?.courses_count} كورس`,
    },
    {
      icon: <FaChartLine className="text-primaryColor text-4xl mb-4" />,
      title: `+${achievements?.books_count} كتاب`,
    },
  ];

  return (
    <div className="w-full max-w-7xl mx-auto">
      <div className="mb-10 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-white">
          إنجازاتنا
        </h2>
        <p className="text-lg md:text-xl text-[#C7D0E0] max-w-2xl mx-auto">
          نفتخر بإنجازاتنا في دعم الطلاب والمعلمين لتحقيق أفضل النتائج.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
        {items.map((item: any, idx: number) => (
          <div
            key={idx}
            className="flex flex-col items-center bg-[#232c37] rounded-2xl p-8 shadow-md hover:shadow-xl transition"
          >
            {item.icon}
            <h3 className="text-xl font-bold text-white mb-2 text-center">
              {item.title}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AchieveYourGoals;
